module.exports = __webpack_public_path__ + "static/bush-mask-ca96379250cdb898d1c84b2bf3a15922.png";